import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Crown, Sparkles } from 'lucide-react';

export default function ArtikelLuxusGeschenke() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />Alle Ratgeber
          </Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4">
            <Calendar className="w-4 h-4" /><span>Februar 2026</span>
          </div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">
            Luxus-Eid-Geschenke: Inspiration für besondere Anlässe
          </h1>
          <p className="text-lg text-white/80 leading-relaxed">
            Exklusive Geschenkideen für Menschen, die Ihnen besonders am Herzen liegen – 
            von Designer-Parfüms bis zu handgefertigten Unikaten.
          </p>
        </div>
      </section>

      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">
            Manchmal möchte man jemandem zeigen, wie besonders er ist – mit einem Geschenk, das 
            keine Wünsche offen lässt. Ob für die Eltern, den Ehepartner oder als Dankeschön für 
            jemanden, der immer für Sie da war: Diese Luxus-Geschenke machen Eid unvergesslich.
          </p>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 md:p-8 mb-12">
            <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">📖 Kategorien</h2>
            <ul className="space-y-2 text-[#4A5D4F]">
              <li><a href="#parfum" className="hover:underline">1. Exklusive Düfte & Parfüms</a></li>
              <li><a href="#schmuck" className="hover:underline">2. Edler Schmuck</a></li>
              <li><a href="#accessoires" className="hover:underline">3. Luxus-Accessoires</a></li>
              <li><a href="#spirituell" className="hover:underline">4. Spirituelle Luxus-Geschenke</a></li>
              <li><a href="#erlebnisse" className="hover:underline">5. Luxus-Erlebnisse</a></li>
            </ul>
          </div>

          <section id="parfum" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-[#4A5D4F]" />
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">1. Exklusive Düfte & Parfüms</h2>
            </div>
            
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Tom Ford Oud Wood</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 180 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Der Klassiker unter den Luxus-Oud-Düften. Holzig, warm und unverwechselbar elegant.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Amouage Interlude</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 250 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Komplexer orientalischer Duft aus Oman – Weihrauch, Oud und Amber in Perfektion.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Maison Francis Kurkdjian Baccarat Rouge 540</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 220 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Ikonischer Duft mit Safran, Jasmin und Zedernholz – ein Statement.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Arabian Oud Kalemat</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 150 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Authentisches Oud aus Saudi-Arabien – traditionell und luxuriös.</p>
              </div>
            </div>
          </section>

          <section id="schmuck" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center">
                <Crown className="w-6 h-6 text-[#4A5D4F]" />
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">2. Edler Schmuck</h2>
            </div>

            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Goldkette mit Diamant-Anhänger</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 300 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">18 Karat Gold mit echtem Diamant – ein Geschenk fürs Leben.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Perlenarmband (Süßwasserperlen)</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 150 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Zeitlose Eleganz – echte Perlen in klassischem Design.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Designerring mit arabischer Kalligraphie</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 200 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Handgefertigt mit eingravierten Koranversen oder Namen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Luxus-Tasbih (Halbedelsteine)</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 100 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Gebetskette aus Türkis, Achat oder Tigerauge mit Silber-Details.</p>
              </div>
            </div>
          </section>

          <section id="accessoires" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center">
                <Gift className="w-6 h-6 text-[#4A5D4F]" />
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">3. Luxus-Accessoires</h2>
            </div>

            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Designer-Uhr</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 300 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Hochwertige Armbanduhr von bekannten Marken – zeitlos und elegant.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Seiden-Hijab-Kollektion</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 150 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Set aus 3-5 Premium-Seiden-Hijabs in verschiedenen Farben.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Designer-Handtasche</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 200 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Elegante Tasche aus hochwertigem Leder – praktisch und stilvoll.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Luxus-Kufi/Taqiyah</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 80 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Handbestickte traditionelle Kopfbedeckung aus hochwertigen Materialien.</p>
              </div>
            </div>
          </section>

          <section id="spirituell" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center">
                <Crown className="w-6 h-6 text-[#4A5D4F]" />
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">4. Spirituelle Luxus-Geschenke</h2>
            </div>

            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Quran mit Goldprägung</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 150 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Handgebundener Quran mit Leder-Einband und Goldverzierungen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Handgeknüpfter Gebetsteppich</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 200 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Traditionell handgeknüpft aus Seide oder hochwertiger Wolle.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Kalligraphie-Kunstwerk (Original)</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 300 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Von einem Kalligraphen handgeschrieben – ein einzigartiges Kunstwerk.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-[#2C332E]">Premium-Bakhoor-Set</h4>
                  <span className="text-[#4A5D4F] font-medium">Ab 120 €</span>
                </div>
                <p className="text-sm text-[#4B5563]">Hochwertiger Weihrauch mit handgefertigtem Räuchergefäß aus Messing.</p>
              </div>
            </div>
          </section>

          <section id="erlebnisse" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-[#4A5D4F]" />
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">5. Luxus-Erlebnisse</h2>
            </div>

            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Spa-Tag im Luxus-Hotel</h4>
                <p className="text-sm text-[#4B5563]">Ein Tag voller Entspannung mit Massage, Hammam und Wellness.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Umrah-Reise (Anteil)</h4>
                <p className="text-sm text-[#4B5563]">Ein Beitrag zur kleinen Pilgerfahrt – das bedeutungsvollste Geschenk überhaupt.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Luxus-Restaurant (Halal)</h4>
                <p className="text-sm text-[#4B5563]">Ein besonderes Eid-Dinner in einem gehobenen Halal-Restaurant.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Wochenend-Trip</h4>
                <p className="text-sm text-[#4B5563]">Ein kurzer Urlaub – gemeinsame Zeit ist das größte Geschenk.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">
              Luxus-Geschenke sind für besondere Menschen und besondere Anlässe. Sie zeigen tiefe 
              Wertschätzung und bleiben ein Leben lang in Erinnerung. Ob exklusiver Duft, edler Schmuck 
              oder ein spirituelles Unikat – das beste Luxusgeschenk ist eines, das von Herzen kommt.
            </p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/guenstige-eid-geschenke" className="text-[#4A5D4F] hover:underline">→ Günstige Eid Geschenke unter 20€</Link></li>
              <li><Link to="/ratgeber/personalisierte-eid-geschenke" className="text-[#4A5D4F] hover:underline">→ Personalisierte Eid Geschenke</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">
              Jetzt stöbern<Gift className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </article>
    </main>
  );
}
